// extracted by mini-css-extract-plugin
module.exports = {"root":"TabNav_root__1umVS","tab":"TabNav_tab__g7tXq","link":"TabNav_link__jSxBH","selectedLink":"TabNav_selectedLink__16eoo","disabled":"TabNav_disabled__1n03p"};